/**
 * Fleet presence helpers — server ``is_online`` / ``map_pulse`` only (no client-invented state).
 *
 * R12b-8: hybrid poll — most ticks hit cached GET paths; periodic ``skip_cache=1`` refresh.
 * FE-C2: poll paths via contract operation_id (10K hybrid poll, no path drift).
 */

import { buildContractPath } from "./api/contract-client.js";

export const DEVICES_API_LIVE = buildContractPath("get__devices", { query: { skip_cache: "1" } });
export const OVERVIEW_API_LIVE = buildContractPath("get__dashboard_overview", { query: { skip_cache: "1" } });
export const DEVICES_API_FAST = buildContractPath("get__devices");
export const OVERVIEW_API_FAST = buildContractPath("get__dashboard_overview");

/** Align with server Redis TTL (12–15s). */
export const FLEET_FULL_REFRESH_MS = 12000;

/** Console cursor page size (matches API default / R12-15c). */
export const FLEET_PAGE_LIMIT = 200;

let _devicesFullAt = 0;
let _overviewFullAt = 0;

/**
 * @param {number} [now]
 * @returns {string}
 */
export function pickDevicesPollPath(now = Date.now()) {
  if (now - _devicesFullAt >= FLEET_FULL_REFRESH_MS) {
    _devicesFullAt = now;
    return DEVICES_API_LIVE;
  }
  return DEVICES_API_FAST;
}

/**
 * @param {number} [now]
 * @returns {string}
 */
export function pickOverviewPollPath(now = Date.now()) {
  if (now - _overviewFullAt >= FLEET_FULL_REFRESH_MS) {
    _overviewFullAt = now;
    return OVERVIEW_API_LIVE;
  }
  return OVERVIEW_API_FAST;
}

/** Reset clocks on logout / tenant switch (optional). */
export function resetFleetPollClocks() {
  _devicesFullAt = 0;
  _overviewFullAt = 0;
}

export { opsMapPresenceStatus as devicePresenceStatus } from "./ops-map-presence-display.js";

/**
 * @param {Record<string, unknown> | null | undefined} d
 * @returns {boolean}
 */
export function deviceReachable(d) {
  if (!d || typeof d !== "object") return false;
  if (typeof d.is_online === "boolean") return d.is_online;
  return false;
}

/**
 * @param {Record<string, unknown> | null | undefined} d
 * @returns {string}
 */
export function deviceStatusLine(d) {
  const sp = /** @type {{ line?: string } | undefined} */ (d && d.status_preview);
  if (sp && String(sp.line || "").trim()) return String(sp.line).trim();
  return "—";
}

/**
 * English badge label for list cards (online | offline | alert).
 * @param {{ label: string; cls: string }} pres
 * @returns {string}
 */
export function devicePresenceBadgeText(pres) {
  if (pres.cls === "alert") return "alert";
  if (pres.cls === "online") return "online";
  return "offline";
}
